module.exports = __webpack_public_path__ + "img/btn-faq.797670ff.jpg";